import React, { useState, useRef, useEffect, useMemo } from 'react';
import { Toast } from 'primereact/toast';
import GenericTableFilter from '../../../../components/common/GenericTableFilter';
import useVehicleWarrantyPeriodData from './hooks/useVehicleWarrantyPeriodData';
import VehicleWarrantyPeriodTable from './components/VehicleWarrantyPeriodTable';
import VehicleWarrantyPeriodForm from './components/VehicleWarrantyPeriodForm';
import { useLanguage } from '../../../../contexts/LanguageContext';

const VehicleAdditionalWarrantyPeriodPage = () => {
    const { th } = useLanguage();
    const [dialogVisible, setDialogVisible] = useState(false);
    const toastRef = useRef(null);

    const {
        apiVehicleWarrantyPeriod,
        isLoading,
        isFetching,
        lazyParams,
        onPage,
        handleFilterChange,
        initFilters,
        saveVehicleWarrantyPeriod,
        selectItem,
        clearSelection,
        selectedItem,
        documents,
        isLoadingDocuments,
        isLoadingSelectedItem,
        handleDocumentDownload,
        setToastRef
    } = useVehicleWarrantyPeriodData();

    useEffect(() => {
        if (toastRef.current) {
            setToastRef(toastRef.current);
        }
    }, [setToastRef]);

    const filterFields = useMemo(() => [
        {
            field: 'carItemCode',
            headerName: th('vehicleAdditionalWarrantyPeriod.filterFields.carItemCode'),
            type: 'text'
        },
        {
            field: 'chassisNo',
            headerName: th('vehicleAdditionalWarrantyPeriod.filterFields.chassisNo'),
            type: 'text'
        }
    ], [th]);
    
    const handleEdit = (rowData) => {
        if (rowData && rowData.id) {
            selectItem(rowData.id);
            setDialogVisible(true);
        }
    };

    const handleHide = () => {
        setDialogVisible(false);
        clearSelection();
    };

    const handleSubmit = async (formData, hasFormChanged) => {
        const success = await saveVehicleWarrantyPeriod(formData, hasFormChanged);
        if (success) {
            handleHide();
        }
    };

    const isTableLoading = isLoading || isFetching;

    return (
        <div className="card">
            <Toast ref={toastRef} />
            <div className="flex justify-content-between align-items-center mb-4">
                <h1 className="m-0">{th('vehicleAdditionalWarrantyPeriod.titleWarrantyPeriod')}</h1>
            </div>

            <div className="mb-2">
                <GenericTableFilter filterFields={filterFields} initialFilters={{}} onSearch={() => { }} onApplyFilters={handleFilterChange} onResetFilters={initFilters} />
            </div>

            <VehicleWarrantyPeriodTable data={apiVehicleWarrantyPeriod?.items} totalCount={apiVehicleWarrantyPeriod?.totalCount} loading={isTableLoading} lazyParams={lazyParams} onPage={onPage} onEdit={handleEdit} />

            <VehicleWarrantyPeriodForm
                visible={dialogVisible}
                onHide={handleHide}
                onSubmit={handleSubmit}
                initialData={selectedItem}
                documents={documents}
                isLoadingDocuments={isLoadingDocuments}
                onDownloadDocument={handleDocumentDownload}
                itemLoading={isLoadingSelectedItem}
            />
        </div>
    );
};

export default VehicleAdditionalWarrantyPeriodPage;
